import React from 'react'
import { motion } from 'framer-motion';
import { pageVariants, pageTransition } from './PageAnimations';


const Projects = (props) => {

    return (
        <motion.div initial="out" animate="in" exit="out" variants={pageVariants} transition={pageTransition} >
            <h2>This is Project Component</h2>
        </motion.div>
    )
}


export default Projects;